import React from "react";

const Container = ({
  children,
  maxWidth = "1200px",
  isAlignTop,
  className,
}) => {
  return (
    <div
      className={`container  max-w-[${maxWidth}] px-4 mx-auto ${
        isAlignTop && " mt-[-50px]"
      } ${className}`}
    >
      {children}
    </div>
  );
};

export default Container;
